export default __webpack_public_path__ + "static/media/gymOwners.37212b41.svg";